import { Card, CardBody, Form } from "reactstrap";
import { H4 } from "../../../../../AbstractElements";
import { ProductImageHeading } from "../../../../../utils/Constant";
import SelectSize from "./SelectSize";
import CommonFileUpload from "../../../../Common/CommonFileUpload";

const ProductImage = () => {
  return (
    <Card>
      <CardBody>
        <div className="product-info">
          <H4>{ProductImageHeading}</H4>
          <Form>
            <CommonFileUpload />
          </Form>
          <SelectSize />
        </div>
      </CardBody>
    </Card>
  );
};

export default ProductImage;
